import { ThemeBrandColors } from "../../types";

export const EducationBrand: ThemeBrandColors = {
  "color-brand-50": "#F9F2F9",
  "color-brand-100": "#F4E5F4",
  "color-brand-200": "#F2D8F6",
  "color-brand-300": "#DFB6E5",
  "color-brand-400": "#CD9CDA",
  "color-brand-500": "#B977C9",
  "color-brand-600": "#A652B8",
  "color-brand-700": "#9121A6",
  "color-brand-800": "#7A1D8E",
  "color-brand-900": "#671E71",
  "color-brand-950": "#42074B"
};
